const SDK_VERSION = '7.19.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
